import serverVars from 'server-vars';

export const isBot = (): boolean => !!serverVars.get('bt');
